import { render } from "./OrderHistoryGrid.vue?vue&type=template&id=5ffc1751"
import script from "./OrderHistoryGrid.vue?vue&type=script&lang=js"
export * from "./OrderHistoryGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__